import {
  clipboardPlainTextBestEffort,
  pastePlainIntoTextarea,
} from "@/components/ads-assistant/adsAssistantClipboardPlainText";

export function AdsAssistantManualPostTextField({
  body,
  setBody,
}: {
  body: string;
  setBody: (v: string) => void;
}) {
  return (
    <label className="text-[11px] text-gray-600 dark:text-gray-400 block">
      Post text (as in the ad)
      <textarea
        className="mt-0.5 w-full rounded border border-gray-200 bg-white px-2 py-1.5 text-sm min-h-[88px] dark:border-gray-600 dark:bg-zinc-950 dark:text-gray-100 [font-family:ui-sans-serif,system-ui,'Segoe_UI',Roboto,'Noto_Sans','Apple_Color_Emoji','Segoe_UI_Emoji','Segoe_UI_Symbol',sans-serif]"
        value={body}
        onChange={(e) => setBody(e.target.value)}
        onPaste={(e) => {
          const pasted = clipboardPlainTextBestEffort(e.clipboardData);
          if (!pasted) return;
          e.preventDefault();
          pastePlainIntoTextarea(e.currentTarget, pasted, setBody);
        }}
        required
      />
      <span className="mt-1 block font-normal text-[10px] text-gray-500 dark:text-gray-500">
        Paste as published — emoji and Unicode are stored in UTF-8 end-to-end (Postgres{" "}
        <code className="rounded bg-gray-200/80 px-0.5 dark:bg-zinc-700">text</code>). If plain paste shows tofu or
        replacement glyphs, we retry from HTML clipboard data when it has fewer damaged characters. You can also use{" "}
        <strong className="font-medium">paste without formatting</strong> (Ctrl+Shift+V) or copy from the live post.
      </span>
    </label>
  );
}
